import { render, staticRenderFns } from "./IdentificacaoPaciente.vue?vue&type=template&id=520a79b0&"
import script from "./IdentificacaoPaciente.vue?vue&type=script&lang=js&"
export * from "./IdentificacaoPaciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports